import {
  Category,
  Subtype,
  Type,
} from '@src/main/modules/parameters/domain/issues/category.interface';

export interface CategoryEntity {
  categoryId: string;
  title: string;
  description: string;
  types: TypeEntity[];
  visibleOnApp: boolean;
}

export interface TypeEntity {
  typeId: string;
  title: string;
  categories?: CategoryEntity[];
  subtypes: SubtypeEntity[];
  visibleOnApp: boolean;
}

export interface SubtypeEntity {
  subtypeId: string;
  title: string;
  types: TypeEntity[];
  visibleOnApp: boolean;
}

export function toCategory(entity: CategoryEntity): Category {
  return {
    categoryId: entity.categoryId,
    description: entity.description,
    title: entity.title,
    types: entity.types ? entity.types.map(toType) : [],
    visibleOnApp: entity.visibleOnApp !== undefined ? entity.visibleOnApp : true,
  };
}

export function fromCategory(model: Category): CategoryEntity {
  return {
    categoryId: model.categoryId || '',
    description: model.description,
    title: model.title,
    types: model.types ? model.types.map(fromType) : [],
    visibleOnApp: model.visibleOnApp,
  };
}

export function toType(entity: TypeEntity): Type {
  return {
    title: entity.title,
    typeId: entity.typeId,
    categories: [],
    subtypes: entity.subtypes ? entity.subtypes.map(toSubtype) : [],
    visibleOnApp: entity.visibleOnApp !== undefined ? entity.visibleOnApp : true,
  };
}

export function fromType(model: Type): TypeEntity {
  return {
    title: model.title,
    typeId: model.typeId || '',
    categories: [],
    subtypes: model.subtypes ? model.subtypes.map(fromSubtype) : [],
    visibleOnApp: model.visibleOnApp,
  };
}

export function toSubtype(entity: SubtypeEntity): Subtype {
  return {
    subtypeId: entity.subtypeId,
    title: entity.title,
    types: [],
    visibleOnApp: entity.visibleOnApp !== undefined ? entity.visibleOnApp : true,
  };
}

export function fromSubtype(model: Subtype): SubtypeEntity {
  return {
    subtypeId: model.subtypeId || '',
    title: model.title,
    types: [],
    visibleOnApp: model.visibleOnApp,
  };
}
